import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URLS } from "../../Config/API_URLS";
import axiosInstance from "../../Config/axios";

function CartPages() {
  const [data, setData] = useState([]);

  const Product = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.productList, reqBody).then((response) => {
      setData(response.data.data.product_list);
    });
  };

  useEffect(() => {
    Product();
  }, []);

  const navigate = useNavigate();
  return (
    <>
      <div className="">
        <div className="bg-gray-200 py-5">
          <div className=" lg:px-40 px-5 grid lg:grid-cols-4   justify-center gap-10">
            {data?.map((item) => {
              return (
                <>
                  <div className=" hht">
                    <div className=" dd">
                      <div className="lazyload-wrapper">
                        <img
                          alt=""
                          src={item.image}
                          className="dd1  text-ellipsis overflow-hidden rounded-2xl"
                        />
                      </div>
                      <div className="dd2">
                        <p className="dd3 text-ellipsis overflow-hidden">
                          {item.title}
                        </p>
                        <p className="text-white text-ellipsis overflow-hidden">
                          {item.variant_name}
                        </p>
                        <div className="flex justify-center gap-5 text-white">
                          <p>{item.stock_sataus}</p>
                          <p>HSN:{item.HSN}</p>
                        </div>

                        <p className="font-bold text-white flex justify-center text-ellipsis overflow-hidden">
                          ₹ {item.price}/-
                        </p>

                        <div className="dd5">
                          <div className="">
                            <button
                              className="b1 "
                              onClick={() => navigate("/yourcart")}
                            >
                              <p className="b3 flex justify-center">Buy </p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="dd7"></div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          {/* <div className=" lg:px-40 py-10 px-3  flex lg:flex-row justify-center flex-col gap-10">
            {data?.map((item) => {
              return (
                <>
                  <div className=" hh">
                    <div className=" dd">
                      <div className="lazyload-wrapper">
                        <img alt="" src={item.product_image} className="dd1" />
                      </div>
                      <div className="dd2">
                        <p className="dd3 ">{item.title}</p>
                        <p className=" dd4">{item.description}</p>
                        <p className="dd4">{item.price}</p>
                        <div className="dd5">
                          <div className="">
                            <button className="b1 !-mt-1 ">
                              <p className="b3">Add</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="dd7"></div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className=" lg:px-40 py-10 px-3  flex lg:flex-row justify-center flex-col gap-10">
            {data?.map((item) => {
              return (
                <>
                  <div className=" hhh">
                    <div className=" dd">
                      <div className="lazyload-wrapper">
                        <img alt="" src={item.product_image} className="dd1" />
                      </div>
                      <div className="dd2">
                        <p className="dd3 ">{item.title}</p>
                        <p className=" dd4">{item.description}</p>
                        <p className="dd4">{item.price}</p>
                        <div className="dd5">
                          <div className="">
                            <button className="b1 !-mt-1 ">
                              <p className="b3">Add</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="dd7"></div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className=" lg:px-40 py-10 px-3 flex lg:flex-row justify-center flex-col gap-10">
            {[{ t: dim }, { t: dim }, { t: dim }, { t: dim }].map((item) => {
              return (
                <>
                  <div className="commm1">
                    <div className=" dd">
                      <div className="lazyload-wrapper">
                        <img alt="" src={dim} className="dd1" />
                      </div>
                      <div className="dd2">
                        <p className="dd3 ">UI Design Quick Apps in Figma</p>
                        <p className=" dd4">50 videos - 12 hours</p>
                        <div className="dd5">
                          <div className="">
                            <button className="b1 !-mt-1 ">
                              <p className="b3">Add</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="dd7"></div>{" "}
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className=" lg:px-40 py-10 px-3  flex lg:flex-row justify-center flex-col gap-10">
            {[{ t: dim }, { t: dim }, { t: dim }, { t: dim }].map((item) => {
              return (
                <>
                  <div className="ppp">
                    <div className=" dd">
                      <div className="lazyload-wrapper">
                        <img alt="" src={dim} className="dd1" />
                      </div>
                      <div className="dd2">
                        <p className="dd3 ">UI Design Quick Apps in Figma</p>
                        <p className=" dd4">50 videos - 12 hours</p>
                        <div className="dd5">
                          <div className="">
                            <button className="b1 !-mt-1 ">
                              <p className="b3">Add</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="dd7"></div>
                    </div>
                  </div>
                </>
              );
            })}
          </div> */}
        </div>
      </div>
      ;
    </>
  );
}

export default CartPages;
